import React from 'react';
import { Form } from 'antd';
import SearchRide from './searchRide/SearchRide';

function SearchRidesList({
  rides, chosenRide, setChosenRide, seatFormationForm,
}) {
  const seatFormation = Form.useWatch('seatFormation', seatFormationForm);

  return (
    <div className="flex flex-col gap-5 w-full">
      {rides?.map((ride) => (
        <SearchRide
          setChosenRide={setChosenRide}
          chosenRide={chosenRide}
          key={ride.id}
          ride={ride}
          seatFormation={seatFormation}
        />
      ))}
    </div>
  );
}

export default SearchRidesList;
